/**
 * consentCookie.ts — ОДНО чтение решения посетителя о согласии.
 *
 * Выделено из `euConsent.ts` карточкой WEB-2146 (остаток отказа приёмки
 * 21.09). Причина ровно одна и она про устройство модулей, а не про красоту:
 * постоянный идентификатор посетителя (`visitorId.ts`) обязан знать решение,
 * чтобы не записывать себя на устройство европейца до «Принять», — а
 * `euConsent.ts` сам зовёт `visitorId.ts` (очистка следа при отказе). Импорт
 * навстречу дал бы круг модулей.
 *
 * Второй копии гейта при этом не заводится (шрам WEB-953 — своя копия
 * расходится молча): решение читает ОДНА функция, `euConsent.ts` её
 * переэкспортирует, и все прежние импортёры продолжают брать её оттуда же.
 */

export const CONSENT_COOKIE = 'w2a_consent';

export type ConsentDecision = 'granted' | 'denied';

/**
 * Решение посетителя, если оно записано. `undefined` — решения ещё нет
 * (куки нет, пустая или незнакомое значение); это НЕ отказ, и путать их
 * нельзя: отказ отзывает согласие, отсутствие решения — просто ждёт ответа.
 */
export function readConsentDecision(): ConsentDecision | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie
    .split(';')
    .find((c) => c.trim().startsWith(`${CONSENT_COOKIE}=`));
  if (!match) return undefined;
  const value = match.split('=')[1]?.trim();
  if (value === 'granted') return 'granted';
  if (value === 'denied') return 'denied';
  return undefined;
}
